import React from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Container, CircularProgress, useMediaQuery, useTheme } from "@material-ui/core";
import Calendar from "./Calendar";
import eventsAPI from "../../restApi/eventsApi";
import { TEAM_COLORS as teamColors } from "../../CONSTANTS";

// TEAM_COLORS is a fixed-size array indexed by team.id - 1 - a team id
// past its end (any id beyond the first few teams ever created) has no
// entry. Mirrors Upcoming.jsx's teamColorFor: fall back to no color
// (FullCalendar's own default) rather than crashing formatEvents, which
// previously left the whole page stuck on its loading spinner.
const teamColorFor = (team) => {
  const color = team && teamColors[team.id - 1];
  return color ? color.main : undefined;
};

const formatEvents = (events) => {
  return events.map((event) => {
    let title = event.name;
    const classNames = [];
    if (event.status === "draft") {
      title = `[Draft] ${title}`;
      classNames.push("draft-event");
    }
    if (event.status === "cancelled") {
      title = `[Cancelled] ${title}`;
      classNames.push("cancelled-event");
    }
    return {
      title,
      start: event.time_start,
      end: event.time_end,
      extendedProps: { team: event.team, id: event.id },
      borderColor: teamColorFor(event.team),
      backgroundColor: "transparent",
      classNames,
    };
  });
};

export default () => {
  const [loading, setLoading] = React.useState(true);
  const [events, setEvents] = React.useState([]);
  const history = useHistory();
  const location = useLocation();
  const theme = useTheme();
  const largeScreen = useMediaQuery(theme.breakpoints.up("sm"));

  /* Fetch the events from the API when component mounts*/
  React.useEffect(() => {
    eventsAPI.getEvents().then((res) => {
      setEvents(formatEvents(res.data));
      setLoading(false);
    });
  }, []);

  // Creating an event lands on the same page as viewing/editing one
  // (/events/new, see EventDetailContainer.jsx), not a modal over the
  // grid - a date range dragged on the calendar just gets forwarded
  // along as router state to pre-fill it there.
  const goToNewEvent = (range) => {
    history.push("/events/new", {
      from: location,
      ...(range && { timeStart: range.start, timeEnd: range.end }),
    });
  };

  return (
    <Container>
      {loading ? (
        <div
          style={{
            position: "absolute",
            top: "30%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <CircularProgress color="secondary" />
        </div>
      ) : (
        <Calendar events={events} goToNewEvent={goToNewEvent} largeScreen={largeScreen} />
      )}
    </Container>
  );
};
